import { useState } from 'react';

export default function CTASection() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [errorMsg, setErrorMsg] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;

    const honeypotField = form.querySelector<HTMLInputElement>('input[name="phone_alt"]');
    if (honeypotField && honeypotField.value.trim() !== '') {
      setStatus('success');
      return;
    }

    setStatus('loading');
    setErrorMsg('');

    try {
      const formData = new FormData(form);
      const response = await fetch('https://readdy.ai/api/form/d9nh0ecit35ii3jdlr4g', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });

      const responseText = await response.text();
      let parsed;
      try { parsed = JSON.parse(responseText); } catch { parsed = null; }

      if (response.ok && parsed?.code === 'OK') {
        setStatus('success');
        setEmail('');
      } else {
        const serverMsg = parsed?.meta?.message || parsed?.meta?.detail || parsed?.message || responseText;
        setStatus('error');
        setErrorMsg(serverMsg || '订阅失败，请稍后重试');
      }
    } catch {
      setStatus('error');
      setErrorMsg('网络错误，请检查连接后重试');
    }
  };

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="relative overflow-hidden rounded-2xl bg-gradient-to-br from-primary-600 via-primary-700 to-foreground-900 px-6 py-12 md:px-12 md:py-16">
          <div className="absolute inset-0 opacity-10">
            <img
              src="https://readdy.ai/api/search-image?query=Abstract%20cinematic%20texture%20background%20with%20soft%20film%20grain%20and%20subtle%20lens%20flare%20effects%2C%20dark%20elegant%20atmosphere%2C%20smooth%20gradient%20from%20deep%20warm%20red%20to%20black%2C%20minimalist%20and%20luxurious&width=1200&height=600&seq=cta-bg&orientation=landscape"
              alt=""
              className="w-full h-full object-cover"
              loading="lazy"
            />
          </div>

          <div className="relative z-10 flex flex-col lg:flex-row items-center justify-between gap-8">
            <div className="text-center lg:text-left">
              <h2 className="text-2xl md:text-3xl font-bold text-background-50 font-heading mb-3">
                不错过任何精彩内容
              </h2>
              <p className="text-sm text-background-300/80 max-w-md">
                订阅我们的更新通知，第一时间获取最新上映的高清电影和热门剧集推送。
              </p>
            </div>

            <div className="w-full lg:w-auto">
              {status === 'success' ? (
                <div className="flex items-center gap-3 bg-background-50/10 backdrop-blur-sm rounded-xl px-6 py-4 border border-background-300/20">
                  <i className="ri-checkbox-circle-fill text-green-400 text-xl"></i>
                  <span className="text-background-200 text-sm font-medium">订阅成功！感谢您的关注</span>
                </div>
              ) : (
                <form
                  onSubmit={handleSubmit}
                  data-readdy-form
                  className="flex flex-col sm:flex-row items-stretch sm:items-center gap-3"
                >
                  <div className="relative flex-1 min-w-[260px]">
                    <i className="ri-mail-line absolute left-4 top-1/2 -translate-y-1/2 text-background-400 text-sm"></i>
                    <input
                      type="email"
                      name="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      placeholder="输入您的邮箱地址"
                      required
                      className="w-full pl-10 pr-4 py-3.5 rounded-xl bg-background-50/10 backdrop-blur-sm border border-background-300/20 text-background-50 placeholder:text-background-400 text-sm focus:outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-400/20 transition-all duration-200"
                    />
                  </div>
                  <input
                    type="text"
                    name="phone_alt"
                    tabIndex={-1}
                    autoComplete="off"
                    aria-hidden="true"
                    readOnly
                    className="spam-field"
                  />
                  <button
                    type="submit"
                    disabled={status === 'loading'}
                    className="px-8 py-3.5 rounded-xl bg-accent-500 text-background-50 font-semibold text-sm hover:bg-accent-400 transition-all duration-300 disabled:opacity-60 whitespace-nowrap cursor-pointer"
                  >
                    {status === 'loading' ? (
                      <span className="flex items-center gap-2">
                        <i className="ri-loader-4-line animate-spin"></i> 订阅中...
                      </span>
                    ) : '立即订阅'}
                  </button>
                </form>
              )}
              {status === 'error' && (
                <p className="text-red-300 text-xs mt-2">{errorMsg}</p>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}